import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import MessagesService from "./MessagesService";

export const GetAllLastChats = createAsyncThunk(
    "messages/lastchats",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let user_id = getState().auth.mainUser.data.id;
            return await MessagesService.GetAllLastChats(user_id);
        } catch (error) {
            let message = error.message;
            console.log("error message", message);
            return rejectWithValue(message);
        }
    }
);

export const SendMessageMethod = createAsyncThunk(
    "messages/send",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let user_id = getState().auth.mainUser.data.id;
            // return await MessagesService.SendMessageMethod({...data, user_sender: user_id});
            return await MessagesService.SendMessageMethod(data);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.errors);
        }
    }
);

export const GetAllMessages = createAsyncThunk(
    "messages/getallmessages",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let user_id = getState().auth.mainUser.data.id;
            return await MessagesService.GetAllMessages({
                ...data,
                auth_user: user_id,
            });
        } catch (error) {
            let message = error.message;
            console.log("error message", message);
            return rejectWithValue(message);
        }
    }
);

export const GetTheNewMessages = createAsyncThunk(
    "messages/getthenewmessages",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let user_id = getState().auth.mainUser.data.id;
            return await MessagesService.GetTheNewMessages({
                ...data,
                auth_user: user_id,
            });
        } catch (error) {
            let message = error.message;
            console.log("error message", message);
            return rejectWithValue(message);
        }
    }
);

export const GetAllDepartments = createAsyncThunk(
    "messages/getalldepertments",
    async (data, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await MessagesService.GetAllDepartments();
        } catch (error) {
            let message = error.message;
            console.log("error message", message);
            return rejectWithValue(message);
        }
    }
);

export const GetUserByRole = createAsyncThunk(
    "messages/getuserbyrole",
    async (data, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await MessagesService.GetUserByRole(data);
        } catch (error) {
            let message = error.message;
            console.log("error message", message);
            return rejectWithValue(message);
        }
    }
);
const MessagesSlice = createSlice({
    name: "messages",
    initialState: {
        messages: [],
        lastChats: [],
        message: [],
        chats: [],
        messages_count: 0,
        sendMessage: [],
        departments: [],
        userRole: [],
        isSuccess: false,
        isError: false,
        isLoading: false,
        errors: [],
    },
    reducers: {
        handelMessageBox: (state) => {
            state.open = !state.open;
        },
        messagesReset: (state) => {
            state.isSuccess = false;
            state.isError = false;
            state.isLoading = false;
            state.errors = [];
        },
        messagesCountSet: (state, action) => {
            state.messages_count = action.payload;
        },
        messagesCountAdd: (state) => {
            state.messages_count = state.messages_count + 1;
            console.log(state.messages_count);
        },
        messagesCountMinus: (state) => {
            state.messages_count = state.messages_count - 1;
        },
    },
    extraReducers: {
        // Get All Last Chats Method
        [GetAllLastChats.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllLastChats.fulfilled]: (state, action) => {
            state.isLoadin = false;
            state.isSuccess = true;
            state.chats = action.payload;
        },
        [GetAllLastChats.rejected]: (state, action) => {
            state.isLoadin = false;
            state.isError = true;
            state.error = action.payload;
        },

        // Send New Message Method
        [SendMessageMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [SendMessageMethod.fulfilled]: (state, action) => {
            state.isLoadin = false;
            state.isSuccess = true;
            state.sendMessage = action.payload;
        },
        [SendMessageMethod.rejected]: (state, action) => {
            state.isLoadin = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Get All Messages Method
        [GetAllMessages.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllMessages.fulfilled]: (state, action) => {
            state.isLoadin = false;
            state.isSuccess = true;
            state.messages = action.payload;
        },
        [GetAllMessages.rejected]: (state, action) => {
            state.isLoadin = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Get All Messages Method
        [GetTheNewMessages.pending]: (state) => {
            state.isLoading = true;
        },
        [GetTheNewMessages.fulfilled]: (state, action) => {
            state.isLoadin = false;
            state.isSuccess = true;
            state.lastChats = action.payload;
        },
        [GetTheNewMessages.rejected]: (state, action) => {
            state.isLoadin = false;
            state.isError = true;
            state.errors = action.payload;
        },
        // Get All Messages Method
        [GetAllDepartments.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllDepartments.fulfilled]: (state, action) => {
            state.isLoadin = false;
            state.isSuccess = true;
            state.departments = action.payload;
        },
        [GetAllDepartments.rejected]: (state, action) => {
            state.isLoadin = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Get All Messages Method
        [GetUserByRole.pending]: (state) => {
            state.isLoading = true;
        },
        [GetUserByRole.fulfilled]: (state, action) => {
            state.isLoadin = false;
            state.isSuccess = true;
            state.userRole = action.payload;
        },
        [GetUserByRole.rejected]: (state, action) => {
            state.isLoadin = false;
            state.isError = true;
            state.errors = action.payload;
        },
    },
});

export const {
    messagesReset,
    handelMessageBox,
    messagesCountSet,
    messagesCountAdd,
    messagesCountMinus,
} = MessagesSlice.actions;
export default MessagesSlice.reducer;
